import { useEffect, useRef, useState, memo } from 'react';

import classNames from './styles.module.css';
import Sparkle from './sparkle';

const SETTINGS = {
  distanceThreshold: 120,
  resolution: 0.5,
  speedRange: 1,
};

const Sparkles = memo(function Sparkles() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [sparkle, setSparkle] = useState<Sparkle>(null!);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  // Intersection Observer to detect when component is in viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 },
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!isVisible || !canvasRef.current || !containerRef.current) {
      return;
    }

    if (!sparkle) {
      const newSparkle = new Sparkle({
        parentContainer: containerRef.current,
        canvasElement: canvasRef.current,
        colorA: [255, 255, 255],
        colorB: [192, 192, 212],
        ...SETTINGS,
      });
      setSparkle(newSparkle);

      // Make canvas visible once initialized
      if (canvasRef.current) {
        canvasRef.current.classList.add(classNames.ready);
      }
    }
  }, [canvasRef, containerRef, SETTINGS, sparkle, isVisible]);

  return (
    <div className={classNames.container} ref={containerRef}>
      <canvas className={classNames.canvas} ref={canvasRef}></canvas>
      <div className={classNames.overlay} />
    </div>
  );
});

export default Sparkles;
